var exports = {
  "qr": "x61f99309--1e72f8--footer",
  "Cy": "x61f99309--1e72f8--user_name",
  "x": "x61f99309--1e72f8--offer",
};

module.exports = exports;
